import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import moment from 'moment';
import { getOccupationResource } from '../../homeManage/request';
import { getPersonnelDetail, insuredPersonnelList, correctSureVerify, policyResource } from '../request.js';
import personnelEntryModel from './personnelEntryModel.vue';
import editPersonnelModel from './editPersonnelModel.vue';
import batchEntryPersonel from './batchEntryPersonel.vue';
import replacePersonnelModel from './replacePersonnelModel.vue';
import correctionSure from './correctionSure.vue';
import { randomLetterNumber } from '@/utils/public.js';
import { ADD, REDUCE, REPLACE, MINPREMIUM, translateReplace, translatePlan } from './util.js';
import mixin from './mixin.js';
let that = null;
export default {
  data() {
    const that = this;
    return {
      date: null,
      name: '',
      idNumber: '',
      remark: '',
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation'
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType'
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber'
      }, {
        slots: {
          title: '责任起期'
        },
        dataIndex: 'startAt',
        key: 'startAt'
      }, {
        slots: {
          title: '责任止期'
        },
        dataIndex: 'endAt',
        key: 'endAt'
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        width: 150,
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      correctionColumns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation'
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType'
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber'
      }, {
        slots: {
          title: '责任起期'
        },
        dataIndex: 'startAt',
        key: 'startAt'
      }, {
        slots: {
          title: '责任止期'
        },
        dataIndex: 'endAt',
        key: 'endAt'
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        width: 150,
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      dataSource: [],
      policyInfo: {},
      yearDays: 365,
      personnelEntryVisible: false,
      correctionDataSource: [],
      professionInfo: [{
        id: 1,
        customerInsuranceId: 102,
        jobNumber: 1,
        occupation: '保安',
        transfer: true
      }],
      editPersonnelModel: false,
      editPersonelObj: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      correctionPagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      editPersonnelVisible: false,
      importVisible: false,
      copyInsuredPersonnelList: [],
      loading: false,
      ADD: ADD,
      REDUCE: REDUCE,
      REPLACE: REPLACE,
      replacePersonnelVisible: false,
      replaceItem: {},
      isEditReplace: false,
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      surePageVisible: false,
      verifyAt: '',
      expandedRowKeys: [],
      sureLoading: false,
      policyPurpose: 'other',
      insurancePlan: [],
      occupationTypeOptions: null
    };
  },
  mixins: [mixin],
  components: {
    personnelEntryModel,
    editPersonnelModel,
    batchEntryPersonel,
    replacePersonnelModel,
    correctionSure
  },
  watch: {
    policyPurpose: {
      handler(val) {
        if (val === 'groupInsurance') {
          this.columns.splice(1, 0, {
            slots: {
              title: '工种类别'
            },
            dataIndex: 'occupationType',
            key: 'occupationType'
          }, {
            slots: {
              title: '保险方案'
            },
            dataIndex: 'insurancePlanName',
            key: 'insurancePlanName'
          }, {
            slots: {
              title: '劳动合同单位（共同被保险人）'
            },
            dataIndex: 'contractCompany',
            key: 'contractCompany',
            width: 180,
            align: 'center'
          }, {
            slots: {
              title: '实际工作单位（派遣单位）'
            },
            dataIndex: 'dispatchCompany',
            key: 'dispatchCompany',
            width: 180,
            align: 'center'
          });
          this.correctionColumns.splice(1, 0, {
            slots: {
              title: '工种类别'
            },
            dataIndex: 'occupationType',
            key: 'occupationType'
          }, {
            slots: {
              title: '保险方案'
            },
            dataIndex: 'insurancePlanName',
            key: 'insurancePlanName'
          }, {
            slots: {
              title: '劳动合同单位（共同被保险人）'
            },
            dataIndex: 'contractCompany',
            key: 'contractCompany',
            width: 180,
            align: 'center'
          }, {
            slots: {
              title: '实际工作单位（派遣单位）'
            },
            dataIndex: 'dispatchCompany',
            key: 'dispatchCompany',
            width: 180,
            align: 'center'
          });
        }
      }
    }
  },
  filters: {
    translate(val) {
      translateReplace.forEach(item => {
        if (val.indexOf(item) !== -1) {
          val = val.replace(item, that.$t(item));
        }
      });
      return val;
    }
  },
  created() {
    that = this;
    this.policyPurpose = this.$route.params.type;
    this.pendingStatusPersonnel = [];
    this.effectiveStatusPersonnel = [];
    this.canceledStatusPersonnel = [];
    this.cancelStatusPersonnel = [];
    this.date = moment().add(1, 'day').format('YYYY-MM-DD');
    getPersonnelDetail({
      policyId: this.$route.params.id
    }).then(res => {
      if (res.insuranceInfo) {
        var _res$insuranceInfo;
        this.policyInfo = res.insuranceInfo;
        this.insurancePlan = ((_res$insuranceInfo = res.insuranceInfo) === null || _res$insuranceInfo === void 0 ? void 0 : _res$insuranceInfo.insurancePlan) || [];
        this.occupationTypeOptions = translatePlan(this.insurancePlan);
        console.log(this.occupationTypeOptions, 'this.occupationTypeOptions');
        this.getOccupation(this.policyInfo.customerInsuranceId);
        if (this.policyInfo.rate && this.policyInfo.rate === 'day') {
          //费率类型为日费率的时候保费除的时候除366
          this.yearDays = 366;
        }
      }
    });
    this.getInsuredPersonnelList();
    this.getPolicyStatusData();
    this.verifyAt = moment().format('YYYY-MM-DD HH:mm:ss');
  },
  mounted() {},
  methods: {
    getPolicyStatusData() {
      //获取待生效 保障中 退保中 已退保的人员数据
      let params = {
        policyId: this.$route.params.id
      };
      policyResource(params).then(res => {
        if (res) {
          this.pendingStatusPersonnel = res.PENDING || [];
          this.effectiveStatusPersonnel = res.EFFECTIVE || [];
          this.canceledStatusPersonnel = res.CANCELED || [];
          this.cancelStatusPersonnel = res.CANCEL || [];
        }
      });
    },
    reduceRevoke(record, index) {
      //减员撤回
      this.changeCorrectionCurrentPage(index);
      let idx = (this.correctionPagination.current - 1) * this.correctionPagination.pageSize + index;
      let item = record.type === REPLACE ? JSON.parse(JSON.stringify(record.reduce)) : JSON.parse(JSON.stringify(record));
      let isMatch = this.checkIsMatch(item);
      this.correctionDataSource.splice(idx, 1);
      let excludeData = this.getCorrectionData();
      if (excludeData[item.idNumber]) {
        //去除在批改列表的数据
        isMatch = false;
      }
      if (isMatch) {
        let obj = {
          id: item.id,
          policyId: item.policyId,
          occupation: item.occupation,
          name: item.name,
          identificationType: item.identificationType,
          idNumber: item.idNumber,
          startAt: item.startAt,
          remark: item.remark || '',
          endAt: item.originalEndAt
        };
        if (this.policyPurpose === 'groupInsurance') {
          obj.occupationType = item.occupationType;
          obj.insurancePlanName = item.insurancePlanName;
          obj.insurancePlanCode = item.insurancePlanCode;
        }
        this.dataSource.unshift(obj);
      }
      //重新 检查数据是否重复
      this.$nextTick(() => {
        this.checkDataRepeat();
      });
      this.resetTotalNum();
    },
    checkIsMatch(item) {
      var _item$idNumber, _item$remark;
      //检查是否匹配
      let isMatch = true;
      const name = this.name.trim();
      const idNumber = this.idNumber.trim();
      const remark = this.remark.trim().toLocaleUpperCase();
      if (name && name !== item.name) {
        isMatch = false;
      }
      if (idNumber && idNumber.toLocaleUpperCase() !== ((_item$idNumber = item.idNumber) === null || _item$idNumber === void 0 ? void 0 : _item$idNumber.toLocaleUpperCase())) {
        isMatch = false;
      }
      let itemMark = (_item$remark = item.remark) === null || _item$remark === void 0 ? void 0 : _item$remark.toLocaleUpperCase();
      if (remark && (itemMark === null || itemMark === void 0 ? void 0 : itemMark.indexOf(remark)) === -1 || !itemMark && remark) {
        isMatch = false;
      }
      // 检测该成员的责任起期是否在生效日期之前
      let effectiveDate = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
      let isBefore = moment(item.startAt).subtract(1, 'seconds').isBefore(effectiveDate);
      if (!isBefore) {
        isMatch = false;
      }
      return isMatch;
    },
    singlyReduce(record, index) {
      var _this$professionInfo$;
      //单个减员
      let endTime = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
      let price = this.calcRealyPrice(endTime, this.policyInfo.endAt, this.policyInfo.premium);
      if (price > 0 && price < MINPREMIUM) {
        this.$message.error(this.$t('保费金额过小无法计算，请联系平台管理员'));
        return;
      }
      this.changeInsureCurrentPage(index);
      let idx = (this.pagination.current - 1) * this.pagination.pageSize + index;
      this.dataSource.splice(idx, 1);
      let premium = this.calcPrice(endTime, this.policyInfo.endAt, this.policyInfo.premium);
      let jobNumber = (_this$professionInfo$ = this.professionInfo.find(v => {
        return v.occupation === record.occupation;
      })) === null || _this$professionInfo$ === void 0 ? void 0 : _this$professionInfo$.jobNumber;
      let rowKey = record.idNumber + this.correctionDataSource.length + randomLetterNumber(4);
      let obj = {
        id: record.id,
        policyId: record.policyId,
        type: REDUCE,
        occupation: record.occupation,
        name: record.name,
        identificationType: record.identificationType,
        idNumber: record.idNumber,
        startAt: record.startAt,
        endAt: moment(this.date).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59',
        originalEndAt: record.endAt,
        remark: record.remark || '',
        premium: premium,
        jobNumber: jobNumber || '',
        rowKey: rowKey
      };
      if (this.policyPurpose === 'groupInsurance') {
        obj.occupationType = record.occupationType;
        obj.insurancePlanCode = record.insurancePlanCode;
        obj.insurancePlanName = record.insurancePlanName;
        obj.contractCompany = record.contractCompany;
        obj.dispatchCompany = record.dispatchCompany;
      }
      this.correctionDataSource.push(obj);
      this.resetTotalNum();
      this.checkDataRepeat();
    },
    resetTotalNum() {
      this.correctionPagination.total = this.correctionDataSource.length;
      this.pagination.total = this.dataSource.length;
    },
    getInsuredPersonnelList() {
      //获取被保人列表
      this.loading = true;
      let params = {
        policyId: this.$route.params.id
      };
      insuredPersonnelList(params).then(res => {
        // this.dataSource = res.items;
        this.copyInsuredPersonnelList = JSON.parse(JSON.stringify(res.items));
        this.pagination.total = Number(res.total);
        this.searchInsuredList();
      }).finally(() => {
        this.loading = false;
      });
    },
    getOccupation(customerInsuranceId) {
      //获取工种
      getOccupationResource({
        customerInsuranceId
      }).then(res => {
        if (res.length > 0) {
          this.professionInfo = res;
        }
      });
    },
    disabledDate(current) {
      //生效日期 日申报只可选择第二天  月申报可以选择往前一个月的日期
      let start = moment().endOf('day');
      if (this.policyInfo.declarationMethod === 'MONTH') {
        start = moment().subtract(1, 'month').subtract(1, 'day');
      }
      let insuranceStartTime = moment(this.policyInfo.startAt).endOf('day');
      if (insuranceStartTime > start) {
        start = insuranceStartTime;
      }
      let insuranceEndTime = moment(this.policyInfo.endAt).endOf('day');
      let endTime = moment().add(1, 'day').endOf('day');
      if (endTime > insuranceEndTime) {
        endTime = insuranceEndTime;
      }
      return current && current > endTime || current < start;
    },
    openChange() {
      //已经设置批改人员时，生效日期发生改变则会清除本次操作的批改人员
      if (this.correctionDataSource.length > 0) {
        this.$confirm({
          title: this.$t('信息提示'),
          content: this.$t('生效日期发生改变则会清除本次操作的批改人员，【确认】后清除，请谨慎操作'),
          okText: this.$t('确认'),
          cancelText: this.$t('取消'),
          onOk: () => {
            this.date = moment().add(1, 'day').format('YYYY-MM-DD');
            this.correctionDataSource = [];
            let data = [];
            this.copyInsuredPersonnelList.forEach(item => {
              let isMatch = true;
              isMatch = this.checkIsMatch(item);
              if (isMatch) {
                data.push(item);
              }
            });
            this.dataSource = data;
            this.resetTotalNum();
          }
        });
      }
    },
    rowClassName(record, index) {
      //设置不同类型数据的背景色
      if (record.type === ADD) {
        return 'add-row';
      } else if (record.type === REDUCE) {
        return 'reduce-row';
      } else if (record.type === REPLACE) {
        return 'replace-row';
      }
    },
    personnelEntrySave(obj) {
      console.log(obj, 'obj');
      obj.rowKey = obj.idNumber + this.correctionDataSource.length + randomLetterNumber(4);
      this.correctionDataSource.push(obj);
      this.personnelEntryVisible = false;
      this.checkDataRepeat();
      this.correctionPagination.total = this.correctionDataSource.length;
    },
    deletePersonnel(index) {
      this.$alert(this.$t('是否确认删除该人员?'), {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        this.changeCorrectionCurrentPage(index);
        let idx = (this.correctionPagination.current - 1) * this.correctionPagination.pageSize + index;
        let deleteItem = this.correctionDataSource[idx];
        this.correctionDataSource.splice(idx, 1);
        this.correctionPagination.total = this.correctionDataSource.length;
        this.$nextTick(() => {
          this.checkDataRepeat();
        });
      });
    },
    checkDataRepeat() {
      //检查数据是否正确
      this.getAddPersonAtCorrectList();
      let expandedRowKeys = [];
      this.correctionDataSource.forEach(item => {
        var _item$errorMessage;
        item.errorMessage = [];
        if (item.type === ADD) {
          //增员
          let message = this.addPersonnelRepeatCheck(item);
          item.errorMessage = message;
        } else if (item.type === REDUCE) {
          //减员
          let message = this.reducePersonnelRepeatCheck(item);
          item.errorMessage = message;
        } else if (item.type === REPLACE) {
          //替换
          let message = [];
          let addMessage = this.addPersonnelRepeatCheck(item.increase);
          let reduceMessage = this.reducePersonnelRepeatCheck(item.reduce);
          message = [...addMessage, ...reduceMessage];
          item.errorMessage = message;
        }
        if (((_item$errorMessage = item.errorMessage) === null || _item$errorMessage === void 0 ? void 0 : _item$errorMessage.length) > 0) {
          expandedRowKeys.push(item.rowKey);
        }
      });
      this.expandedRowKeys = [...expandedRowKeys];
    },
    editPersonnel(record, index) {
      //批改人员的新增人员和替换人员的编辑
      let idx = (this.correctionPagination.current - 1) * this.correctionPagination.pageSize + index;
      if (record.type === ADD) {
        //增员的编辑
        this.editPersonnelVisible = true;
        this.editPersonelObj = record;
        this.editPersonelObj.index = idx;
      } else if (record.type === REPLACE) {
        //替换人员的编辑
        this.isEditReplace = true;
        this.replaceItem = record;
        this.replaceItem.idx = idx;
        this.replacePersonnelVisible = true;
      }
    },
    editPersonnelSave(obj) {
      this.correctionDataSource.splice(obj.index, 1, obj);
      this.editPersonnelVisible = false;
      this.checkDataRepeat();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
    },
    handlerCorrectionTableChange(val) {
      this.correctionPagination = val;
      this.$nextTick(() => {
        this.resetExpandKey();
      });
    },
    resetExpandKey() {
      let expandedRowKeys = [];
      this.correctionDataSource.forEach(item => {
        var _item$errorMessage2;
        if (((_item$errorMessage2 = item.errorMessage) === null || _item$errorMessage2 === void 0 ? void 0 : _item$errorMessage2.length) > 0) {
          expandedRowKeys.push(item.rowKey);
        }
      });
      this.expandedRowKeys = [...expandedRowKeys];
    },
    searchInsuredList() {
      //在保人员查询
      this.pagination.current = 1;
      let searchData = [];
      let excludeData = this.getCorrectionData();
      this.copyInsuredPersonnelList.forEach(item => {
        let isMatch = true;
        isMatch = this.checkIsMatch(item);
        if (excludeData[item.idNumber.toLocaleUpperCase()] && excludeData[item.idNumber.toLocaleUpperCase()] === item.name) {
          //去除在批改列表的数据
          isMatch = false;
        }
        if (isMatch) {
          searchData.push(item);
        }
      });
      this.dataSource = searchData;
      this.pagination.total = this.dataSource.length;
    },
    getCorrectionData() {
      //获取已经在批改列表的数据
      let excludeData = {};
      this.correctionDataSource.forEach(item => {
        if (item.type === REDUCE) {
          excludeData[item.idNumber.toLocaleUpperCase()] = item.name;
        } else if (item.type === REPLACE) {
          excludeData[item.reduce.idNumber.toLocaleUpperCase()] = item.reduce.name;
        }
      });
      return excludeData;
    },
    reset() {
      this.name = '';
      this.idNumber = '';
      this.remark = '';
      this.dataSource = [];
      let excludeData = this.getCorrectionData();
      let copyData = JSON.parse(JSON.stringify(this.copyInsuredPersonnelList));
      copyData.forEach(item => {
        let isMatch = true;
        if (excludeData[item.idNumber.toLocaleUpperCase()] && excludeData[item.idNumber.toLocaleUpperCase()] === item.name) {
          //去除在批改列表的数据
          isMatch = false;
        }
        // 检测该成员的责任起期是否在生效日期之前
        let effectiveDate = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
        let isBefore = moment(item.startAt).subtract(1, 'seconds').isBefore(effectiveDate);
        if (!isBefore) {
          isMatch = false;
        }
        if (isMatch) {
          this.dataSource.push(item);
        }
      });
      this.pagination.current = 1;
      this.pagination.total = this.dataSource.length;
    },
    changeInsureCurrentPage(index) {
      //在保列表如果删除的时候在最后一页 删除完最后一页需要手动改变当前的current
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataSource.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
    },
    changeCorrectionCurrentPage(index) {
      if ((this.correctionPagination.current - 1) * this.correctionPagination.pageSize + index >= this.correctionDataSource.length) {
        this.correctionPagination.current = this.correctionPagination.current - 1 < 1 ? 1 : this.correctionPagination.current - 1;
      }
    },
    replacePersonnel(item, index) {
      var _this$identificationT, _this$professionInfo$2;
      //替换人员在表格中的index
      this.changeInsureCurrentPage(index);
      let idx = (this.pagination.current - 1) * this.pagination.pageSize + index;
      let endAt = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
      let premium = this.calcPrice(endAt, this.policyInfo.endAt, this.policyInfo.premium);
      let price = this.calcRealyPrice(endAt, this.policyInfo.endAt, this.policyInfo.premium);
      let identificationValue = (_this$identificationT = this.identificationTypeData.find(v => {
        return v.label === item.identificationType;
      })) === null || _this$identificationT === void 0 ? void 0 : _this$identificationT.value;
      let jobNumber = (_this$professionInfo$2 = this.professionInfo.find(v => {
        return v.occupation === item.occupation;
      })) === null || _this$professionInfo$2 === void 0 ? void 0 : _this$professionInfo$2.jobNumber;
      // 生成减员的数据
      let reduce = {
        type: REDUCE,
        occupation: item.occupation,
        name: item.name,
        identificationType: item.identificationType,
        identificationValue: identificationValue,
        idNumber: item.idNumber,
        jobNumber: jobNumber,
        startAt: item.startAt,
        endAt: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00',
        remark: item.remark || '',
        premium: premium
      };
      // 生成增员的数据
      let increase = {
        type: ADD,
        startAt: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00',
        premium: premium,
        // occupation: item.occupation,
        occupationType: item.occupationType,
        insurancePlanCode: item.insurancePlanCode,
        insurancePlanName: item.insurancePlanName
      };
      if (this.policyPurpose === 'groupInsurance') {
        reduce.occupationType = item.occupationType;
        reduce.insurancePlanCode = item.insurancePlanCode;
        reduce.insurancePlanName = item.insurancePlanName;
        reduce.contractCompany = item.contractCompany;
        reduce.dispatchCompany = item.dispatchCompany;
        increase.occupationType = item.occupationType;
        increase.insurancePlanCode = item.insurancePlanCode;
        increase.insurancePlanName = item.insurancePlanName;
        increase.contractCompany = '';
        increase.dispatchCompany = '';
      }
      item.idx = idx;
      item.reduce = reduce;
      item.increase = increase;
      item.price = price;
      this.replaceItem = item;
      this.replaceItem.originStartAt = item.startAt;
      this.replacePersonnelVisible = true;
    },
    saveReplace(obj, isEdit) {
      // 替换人员保存
      this.replacePersonnelVisible = false;
      if (isEdit) {
        //编辑替换人员
        this.correctionDataSource.splice(obj.idx, 1, obj);
      } else {
        this.dataSource.splice(obj.idx, 1);
        obj.rowKey = obj.idNumber + this.correctionDataSource.length + randomLetterNumber(4);
        this.correctionDataSource.push(obj);
        this.resetTotalNum();
      }
      this.checkDataRepeat();
      this.isEditReplace = false;
    },
    importSave(dataList, relatedRelationships) {
      //批量录入保存
      this.importVisible = false;
      dataList.forEach(item => {
        //判断是否是替换人员
        let isReplace = relatedRelationships.findIndex(v => {
          return v.addIndex === item.index || v.reduceIndex === item.index;
        });
        let rowKey = item.idNumber + this.correctionDataSource.length + randomLetterNumber(4);
        if (item.recordType === ADD && isReplace === -1) {
          //只是新增人员
          let obj = {
            type: ADD,
            occupation: item.occupation,
            name: item.name,
            rowKey: rowKey,
            identificationType: item.identificationType,
            idNumber: item.idNumber,
            startAt: item.effectDate + ' 00:00:00',
            endAt: this.policyInfo.endAt,
            remark: item.remark || '',
            premium: item.premium,
            jobNumber: item.jobNumber
          };
          if (this.policyPurpose === 'groupInsurance') {
            obj.occupationType = item.occupationType;
            obj.insurancePlanCode = item.insurancePlanCode;
            obj.insurancePlanName = item.insurancePlanName;
            obj.contractCompany = item.contractCompany;
            obj.dispatchCompany = item.dispatchCompany;
          }
          this.correctionDataSource.push(obj);
          this.correctionPagination.total = this.correctionDataSource.length;
        } else if (item.recordType === REDUCE && isReplace === -1) {
          var _this$identificationT2;
          //只是减员人员
          let matchItemIndex = this.dataSource.findIndex(v => {
            return v.idNumber === item.idNumber;
          });
          let identificationValue = (_this$identificationT2 = this.identificationTypeData.find(v => {
            return v.label === item.identificationType;
          })) === null || _this$identificationT2 === void 0 ? void 0 : _this$identificationT2.value;
          let matchItem = this.copyInsuredPersonnelList.find(v => {
            return v.idNumber === item.idNumber;
          });
          let obj = {
            type: REDUCE,
            occupation: item.occupation,
            name: item.name,
            identificationType: item.identificationType,
            identificationValue: identificationValue,
            idNumber: item.idNumber,
            startAt: matchItem.startAt,
            idx: matchItemIndex,
            rowKey: rowKey,
            endAt: item.effectDate + ' 00:00:00',
            originalEndAt: matchItem.endAt,
            remark: matchItem.remark || '',
            premium: item.premium,
            jobNumber: item.jobNumber
          };
          if (this.policyPurpose === 'groupInsurance') {
            obj.occupationType = item.occupationType;
            obj.insurancePlanCode = item.insurancePlanCode;
            obj.insurancePlanName = item.insurancePlanName;
            obj.contractCompany = item.contractCompany;
            obj.dispatchCompany = item.dispatchCompany;
          }
          this.correctionDataSource.push(obj);
          if (matchItemIndex !== -1) {
            this.dataSource.splice(matchItemIndex, 1);
          }
          this.resetTotalNum();
        } else if (isReplace !== -1 && item.recordType === ADD) {
          var _this$identificationT3, _this$identificationT4;
          //替换人员
          let reduceItem = dataList.find(v => {
            return v.index === relatedRelationships[isReplace].reduceIndex;
          });
          let matchReduceIndex = this.dataSource.findIndex(v => {
            return v.idNumber === reduceItem.idNumber;
          });
          let reduceDataItem = this.copyInsuredPersonnelList.find(v => {
            return v.idNumber === reduceItem.idNumber;
          });
          let IncreIdentificationValue = (_this$identificationT3 = this.identificationTypeData.find(v => {
            return v.label === item.identificationType;
          })) === null || _this$identificationT3 === void 0 ? void 0 : _this$identificationT3.value;
          let reduceIdentificationValue = (_this$identificationT4 = this.identificationTypeData.find(v => {
            return v.label === item.identificationType;
          })) === null || _this$identificationT4 === void 0 ? void 0 : _this$identificationT4.value;
          let obj = {
            type: REPLACE,
            occupation: item.occupation,
            name: item.name,
            identificationType: item.identificationType,
            idNumber: item.idNumber,
            // insurancePlanName: item.insurancePlanName,
            // insurancePlanCode: item.insurancePlanCode,
            startAt: item.effectDate + ' 00:00:00',
            endAt: this.policyInfo.endAt,
            remark: item.remark || '',
            premium: item.premium,
            rowKey: rowKey,
            jobNumber: item.jobNumber,
            originStartAt: reduceDataItem.startAt,
            idx: matchReduceIndex,
            reduce: {
              type: REDUCE,
              occupation: reduceItem.occupation,
              // occupationType: reduceItem.occupationType,
              name: reduceItem.name,
              identificationType: reduceItem.identificationType,
              idNumber: reduceItem.idNumber,
              // insurancePlanName: reduceItem.insurancePlanName,
              // insurancePlanCode: reduceItem.insurancePlanCode,
              identificationValue: reduceIdentificationValue,
              startAt: reduceDataItem.startAt,
              endAt: reduceItem.effectDate + ' 00:00:00',
              remark: reduceDataItem.remark || '',
              premium: reduceItem.premium,
              jobNumber: reduceItem.jobNumber,
              originalEndAt: reduceDataItem.endAt
            },
            increase: {
              type: ADD,
              occupation: item.occupation,
              // occupationType: item.occupationType,
              name: item.name,
              // insurancePlanName: item.insurancePlanName,
              // insurancePlanCode: item.insurancePlanCode,
              identificationType: item.identificationType,
              identificationValue: IncreIdentificationValue,
              idNumber: item.idNumber,
              startAt: item.effectDate + ' 00:00:00',
              endAt: this.policyInfo.endAt,
              remark: item.remark || '',
              premium: item.premium,
              jobNumber: item.jobNumber
            }
          };
          if (this.policyPurpose === 'groupInsurance') {
            obj.reduce.occupationType = reduceItem.occupationType;
            obj.reduce.insurancePlanName = reduceItem.insurancePlanName;
            obj.reduce.insurancePlanCode = reduceItem.insurancePlanCode;
            obj.reduce.contractCompany = reduceItem.contractCompany;
            obj.reduce.dispatchCompany = reduceItem.dispatchCompany;
            obj.increase.occupationType = item.occupationType;
            obj.increase.contractCompany = item.contractCompany;
            obj.increase.dispatchCompany = item.dispatchCompany;
            obj.increase.insurancePlanName = item.insurancePlanName;
            obj.increase.insurancePlanCode = item.insurancePlanCode;
            obj.occupationType = item.occupationType;
            obj.insurancePlanName = item.insurancePlanName;
            obj.insurancePlanCode = item.insurancePlanCode;
            obj.contractCompany = item.contractCompany;
            obj.dispatchCompany = item.dispatchCompany;
          }
          this.correctionDataSource.push(obj);
          if (obj.idx !== -1) {
            this.dataSource.splice(obj.idx, 1);
          }
          this.resetTotalNum();
        }
      });
      this.checkDataRepeat();
    },
    sure() {
      if (this.correctionDataSource.length === 0) {
        this.$message.error(this.$t('本次批改未发生人员变化，请选择后提交'));
        return;
      }
      let hasError = false;
      let index = 0;
      for (let i = 0; i < this.correctionDataSource.length; i++) {
        let item = this.correctionDataSource[i];
        if (item.errorMessage && item.errorMessage.length > 0) {
          index = i;
          hasError = true;
          break;
        }
      }
      if (hasError) {
        //如果有错误信息则跳转到第一个错误信息的地方
        this.$message.error(this.$t('请修改完错误项后点击确认'));
        let page = parseInt(index / this.correctionPagination.pageSize) + 1;
        this.correctionPagination.current = page;
        return;
      }
      let data = JSON.parse(JSON.stringify(this.correctionDataSource));
      let personnelDetailsData = data.map(item => {
        if (item.type === REPLACE) {
          item.recordType = ADD;
          item.jobNumber = item.increase.jobNumber;
          item.premium = item.increase.premium;
          item.effectDate = item.increase.startAt;
          item.reduce.recordType = REDUCE;
          item.reduce.endAt = moment(this.date).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
          item.increase.recordType = ADD;
          item.reduce.effectDate = item.reduce.endAt;
          item.increase.effectDate = item.increase.startAt;
        } else if (item.type === REDUCE) {
          //减员的信息 责任起期为生效日期的前一天  责任止期为生效日期的前一天
          item.endAt = moment(this.date).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
          item.effectDate = item.endAt;
          item.recordType = item.type;
        } else if (item.type === ADD) {
          item.effectDate = item.startAt;
          item.recordType = item.type;
        }
        return item;
      });
      let params = {
        policyId: this.$route.params.id,
        personnelDetailsData
      };
      this.expandedRowKeys = [];
      this.sureLoading = true;
      correctSureVerify(params).then(res => {
        if (res.status === 'SUCCESS') {
          this.surePageVisible = true;
        } else {
          this.correctionDataSource = res.data.map((item, index) => {
            //生成唯一的key idNumber + index + 3位随机数
            item.rowKey = item.idNumber + index + randomLetterNumber(4);
            if (item.errorMessage && item.errorMessage.length > 0) {
              this.expandedRowKeys.push(item.rowKey);
            }
            if (item.type === REDUCE) {
              item.endAt = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
            } else if (item.type === REPLACE) {
              item.reduce.endAt = moment(this.date).format('YYYY-MM-DD') + ' 00:00:00';
            }
            return item;
          });
        }
      }).finally(() => {
        this.sureLoading = false;
      });
    },
    expandedRowsChange(val) {
      this.expandedRowKeys = val;
    },
    getAddPersonAtCorrectList() {
      this.addPersonAtCorrectList = {};
      this.correctionDataSource.forEach(item => {
        if (item.type === ADD || item.type === REDUCE) {
          let idNumber = item.idNumber.trim();
          if (this.addPersonAtCorrectList[idNumber]) {
            this.addPersonAtCorrectList[idNumber]++;
          } else {
            this.addPersonAtCorrectList[idNumber] = 1;
          }
        } else if (item.type === REPLACE) {
          let increaseIdNumber = item.increase.idNumber.trim();
          if (this.addPersonAtCorrectList[increaseIdNumber]) {
            this.addPersonAtCorrectList[increaseIdNumber]++;
          } else {
            this.addPersonAtCorrectList[increaseIdNumber] = 1;
          }
          let reduceIdNumber = item.reduce.idNumber.trim();
          if (this.addPersonAtCorrectList[reduceIdNumber]) {
            this.addPersonAtCorrectList[reduceIdNumber]++;
          } else {
            this.addPersonAtCorrectList[reduceIdNumber] = 1;
          }
        }
      });
    },
    addPersonnelRepeatCheck(item) {
      let errorMessage = [];
      let idNumber = item.idNumber;
      if (this.addPersonAtCorrectList[idNumber] > 1) {
        //与本次批改列表重复
        let message = `证件号码${idNumber}在本次批改内存在多条重复数据，请勿重复添加！`;
        errorMessage.push(message);
      } else if (this.pendingStatusPersonnel.filter(item1 => item1.idNumber === idNumber).length) {
        //与待生效成员重复
        let message = `证件号码${idNumber}在本保单内已存在投保信息，请勿重复添加！`;
        errorMessage.push(message);
      } else if (this.effectiveStatusPersonnel.filter(item1 => item1.idNumber === idNumber).length) {
        //与保障中成员重复
        let message = `证件号码${idNumber}在本保单内已存在投保信息，请勿重复添加！`;
        errorMessage.push(message);
      } else if (this.cancelStatusPersonnel.filter(item1 => item1.idNumber === idNumber).length) {
        //与退保中成员重复
        let cancelItem = this.cancelStatusPersonnel.find(item1 => item1.idNumber === idNumber);
        let cancelEndAt = moment(cancelItem.endAt).format('YYYY-MM-DD HH:mm:ss');
        let startAt = moment(item.startAt).format('YYYY-MM-DD HH:mm:ss');
        let isBefore = moment(startAt).isBefore(cancelEndAt);
        if (isBefore) {
          let message = `证件号码${idNumber}在本保单内已存在投保信息，请勿重复添加！`;
          errorMessage.push(message);
        }
      }
      return errorMessage;
    },
    reducePersonnelRepeatCheck(item) {
      let errorMessage = [];
      let idNumber = item.idNumber;
      if (this.addPersonAtCorrectList[idNumber] > 1) {
        //与本次批改列表重复
        let message = `证件号码${idNumber}在本次批改内存在多条重复数据，请勿重复添加！`;
        errorMessage.push(message);
      }
      // else if (this.cancelStatusPersonnel.filter(item => item.idNumber === idNumber).length) {
      //   //与退保中成员重复
      //   let message = `证件号码${idNumber}在本保单内已存在退保中信息，请勿重复添加！`;
      //   errorMessage.push(message);
      // }
      return errorMessage;
    }
  }
};